<template>
    <h1>Emails Scheduled List</h1>
</template>

<script>
    export default {
        name: 'EmailsScheduled'
    };
</script>
